module.exports = __webpack_public_path__ + "img/06.acd959e5.png";